import { createSearchParams } from "react-router-dom"

import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { SettingsAutoConversionStepUi } from "@src/widgets/onboarding/ui/tours/MandatoryInitialSetup/steps/SettingsAutoConversionStepUi"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"

export class SettingsAutoConversionStep extends TourStepBase {
  component = SettingsAutoConversionStepUi
  name = `${ONBOARDING_TOURS.MANDATORY_INITIAL_SETUP}_SettingsAutoConversion`

  constructor() {
    super({
      highlightElements: ["#GENERATED_ID_CONVERSIONFORM_FORM_VOID_1"],
      placement: TOUR_MODAL_PLACEMENTS.BOTTOM,
    })
  }

  action() {
    return router.navigate({
      pathname: paths.settings,
      search: `?${createSearchParams({ tab: "acp" })}`,
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      pic: this.name,
      subtitle: "Select your preferred cryptocurrency for exchange",
      title: "Autoconversion Option",
    }
  }
}
